import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';
import { withBuyonlineAccessToken } from '../core/buy-insurance-access.util';
import { decryptData } from '../core/utilities';

import { BaseComponents } from '../base.component';

@Injectable()
export class VerifyOTPService extends BaseComponents{
  constructor(
    protected injectorObj:Injector,
    public httpClient: HttpClient, 
    public wpTokenService: WpTokenService,
    //private logger: NGXLogger
  ) {
    super(injectorObj);
  }

  private VERIFY_TOKEN_EXPIRE = false;

  httpClientOptions() {
    // TODO: Stuff
    const httpClientOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      observe: 'response' as 'body'
    };
    if(this.VERIFY_TOKEN_EXPIRE){
      let token = this.wpTokenService.getToken();
      httpClientOptions.headers['Authorization'] = token;
    }
    return httpClientOptions;
  }

  input(param: any) {
    return param;
  }

  output(result: any) {
    return result;
  }

  connector(param: any) {
    const url = `${environment.endpointBackend}/api/verifyOTP`;
    // Buy-online sends referenceID (and its access token) so the server marks the purchase
    // OTP-verified; LINE register verifies without one.
    const body = param?.referenceID
      ? withBuyonlineAccessToken(param.referenceID, this.input(param))
      : this.input(param);
    return this.httpClient.post(url, body, this.httpClientOptions());
  }

  // Core Function ! No modify
  exec(param: any) {
    const self = this;
    return new Promise(function(resolve, reject) {
      if(!self.VERIFY_TOKEN_EXPIRE || !self.wpTokenService.isTokenExpired()){
        self.connector(param).subscribe(
          res => {
            self.wpTokenService.storeToken(res['headers'].get('Authorization'));
            //resolve(self.output(res['body']));
            let data = res['body']['data']
            try {
              data = decryptData(data)
              data = JSON.parse(data)
            } catch (error) {
              data = null
            }
            self.logger.debug('verifyOTP>data',data)
            resolve(self.output(data))
          },
          err => {
            self.logger.debug('verifyOTP>err',err)
            reject(err);
          }
        );
      } else {
        reject({
          name: 'WP_TOKEN_EXCEPTION',
          httpStatus:  401,
          message: 'token is expired'
        });
      }
    });
  }
}
